import React from 'react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from './select';

interface TimezoneSelectProps {
    value: string;
    onValueChange: (value: string) => void;
    className?: string;
}

// Common timezones
const timezones = [
    { value: 'UTC', label: 'UTC (Temps Universel)' },
    { value: 'Africa/Abidjan', label: 'Abidjan (GMT)' },
    { value: 'Africa/Dakar', label: 'Dakar (GMT)' },
    { value: 'Europe/Paris', label: 'Paris (GMT+1/GMT+2)' },
    { value: 'Europe/London', label: 'Londres (GMT/GMT+1)' },
    { value: 'America/New_York', label: 'New York (EST/EDT)' },
    { value: 'America/Los_Angeles', label: 'Los Angeles (PST/PDT)' },
    { value: 'America/Montreal', label: 'Montréal (EST/EDT)' },
];

export const TimezoneSelect: React.FC<TimezoneSelectProps> = ({
    value,
    onValueChange,
    className,
}) => {
    return (
        <Select value={value} onValueChange={onValueChange}>
            <SelectTrigger className={className}>
                <SelectValue placeholder="Sélectionnez votre fuseau horaire" />
            </SelectTrigger>
            <SelectContent>
                {timezones.map((tz) => (
                    <SelectItem key={tz.value} value={tz.value}>
                        {tz.label}
                    </SelectItem>
                ))}
            </SelectContent>
        </Select>
    );
};
